import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ruleazaTargetareDescoperire } from "@/api/endpoints/targetareContacte";
import { queryKeys } from "@/lib/queryClient";

export function useRuleazaTargetareDescoperire() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ruleazaTargetareDescoperire,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.contacteStats(),
      });
    },
  });
}
